module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "sec-6"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "pA8E"
    }
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OICES")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0em"
    },
    attrs: {
      "id": "pAoc"
    }
  }, [_c('i', [_vm._v("Sermons by Women in the Churches of Christ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "pAq0"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.png",
      "id": "Aq0",
      "src": "images/himg-6-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pA0a"
    }
  }, [_vm._v("\n\t\t\t\t\tCopyright © 2015 by D’Esta Love"), _c('br'), _vm._v("\n\t\t\t\t\tISBN 978-0-89112-588-4 | LCCN 2015003074"), _c('br'), _vm._v("\n\t\t\t\t\tPrinted in the United States of America")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-2"
    }
  }, [_vm._v("\n\t\t\t\t\tALL RIGHTS RESERVED | No part of this publication may be reproduced, stored in a\n\t\t\t\t\tretrieval system, or transmitted in any form by any means—electronic, mechanical,\n\t\t\t\t\tphotocopying, recording, or otherwise—without prior written consent. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-3"
    }
  }, [_vm._v("\n\t\t\t\t\tAll scripture quotations, unless otherwise indicated, are taken from the Holy Bible,\n\t\t\t\t\tNew International Version®, NIV®. Copyright ©1973, 1978, 1984, 2011 by Biblica, Inc.™\n\t\t\t\t\tUsed by permission of Zondervan. All rights reserved worldwide. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-4"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture quotations noted "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NRSV")]), _vm._v(" are taken from the New Revised Standard Version Bible,\n\t\t\t\t\tcopyright © 1989, the Division of Christian Education of the National Council of\n\t\t\t\t\tthe Churches of Christ in the United States of America. Used by permission. All rights\n\t\t\t\t\treserved. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-5"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture quotations noted "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(" are taken from the Revised Standard Version of the\n\t\t\t\t\tBible, copyright 1952 [2nd edition, 1971] by the Division of Christian Education\n\t\t\t\t\tof the National Council of the Churches of Christ in the United States of America.\n\t\t\t\t\tUsed by permission. All rights reserved. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-6"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture quotations noted "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v(" are taken from the New American Standard Bible"), _c('sup', [_vm._v("®")]), _vm._v(" Copyright\n\t\t\t\t\t© 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation.\n\t\t\t\t\tUsed by permission. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-7"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture quotations noted "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLT")]), _vm._v(" are taken from the New Living Translation, Copyright\n\t\t\t\t\t©1996, 2004, 2007 by Tyndale House Foundation. Used by permission of Tyndale House\n\t\t\t\t\tPublishers, Inc., Carol Stream, IL 60188. All rights reserved. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-8"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture quotations noted "), _c('i', [_vm._v("The Message")]), _vm._v(" taken from "), _c('i', [_vm._v("The Message")]), _vm._v(". Copyright 1993, 1994,\n\t\t\t\t\t1995, 1996, 2000, 2001, 2002. Used by permission of NavPress Publishing Group. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-9"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture texts in this work noted "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NABRE")]), _vm._v(" are taken from the "), _c('i', [_vm._v("New American Bible, revised\n\t\t\t\t\tedition")]), _vm._v(" © 2010, 1991, 1986, 1970 Confraternity of Christian Doctrine, Washington,\n\t\t\t\t\tD.C. and are used by permission of the copyright owner. All Rights Reserved. No part\n\t\t\t\t\tof the New American Bible may be reproduced in any form without permission in writing\n\t\t\t\t\tfrom the copyright owner. ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz6-10"
    }
  }, [_vm._v("\n\t\t\t\t\tLIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA"), _c('br'), _vm._v("\n\t\t\t\t\tFinding their voices : sermons by women in the Church of Christ [edited by] D’Esta\n\t\t\t\t\tlove."), _c('br'), _vm._v("\n\t\t\t\t\t  pages cm"), _c('br'), _vm._v("\n\t\t\t\t\tISBN 978-0-89112-588-4"), _c('br'), _vm._v("\n\t\t\t\t\t1. Churches of Christ--Sermons. 2. Sermons, American--Women authors. I. Love, D’Esta,\n\t\t\t\t\teditor."), _c('br'), _vm._v("\n\t\t\t\t\tBX7077.Z6A29 2015"), _c('br'), _vm._v("\n\t\t\t\t\t252’.0663--dc23\n\t\t\t\t\t                        2015003074")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-11"
    }
  }, [_vm._v("\n\t\t\t\t\tCover design by Thinkpen Design, LLC | Interior text design by Sandy Armstrong, Strong\n\t\t\t\t\tDesign ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-12"
    }
  }, [_vm._v("\n\t\t\t\t\tCover photo: Stauffer Chapel, Photographer Jake Alba, Courtesy of Pepperdine University\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz6-13"
    }
  }, [_vm._v("\n\t\t\t\t\tFor information, contact:"), _c('br'), _vm._v("\n\t\t\t\t\tAbilene Christian University Press"), _c('br'), _vm._v("\n\t\t\t\t\tACU Box 29138, Abilene, Texas 79699")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-16"
    }
  }, [_vm._v("\n\t\t\t\t\t1-877-816-4455 | "), _c('a', {
    attrs: {
      "href": "http://www.acupressbooks.com",
      "id": "A__X",
      "target": "_blank"
    }
  }, [_vm._v("www.acupressbooks.com")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "pz6-17"
    }
  }, [_vm._v("\n\t\t\t\t\t15 16 17 18 19 20 / 7 6 5 4 3 2 1 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 66
// module chunks = 0